<template>
  <a-config-provider :locale="locale">
    <div class="app">
      <!-- <div id="nav">
      <router-link to="/">Home</router-link> |
      <router-link to="/login/login">login</router-link>
    </div> -->
      <router-view />
    </div>
  </a-config-provider>
</template>
<script>
import zhCN from 'ant-design-vue/es/locale/zh_CN';
export default {
  data() {
    return {
      uploadUrl: 'http://101.34.155.172:7002/file/upload',
      locale: zhCN,
    }
  },
  created() {

  }
}
</script>
<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
